<template>
  <section id="client-logos" class="py-12 bg-white dark:bg-dark-surface border-y border-gray-100 dark:border-indigo-900/50 overflow-hidden transition-colors duration-300">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-8">
        <h2 class="text-sm font-semibold text-primary dark:text-accent tracking-widest uppercase transition-colors duration-300">{{ t('clientLogos.title') }}</h2>
        <p class="mt-2 text-base text-gray-500 dark:text-gray-400 transition-colors duration-300">{{ t('clientLogos.subtitle') }}</p>
      </div>
      <div class="relative flex overflow-x-hidden">
        <div class="animate-marquee whitespace-nowrap flex items-center py-4">
          <div v-for="logo in cloudPartners" :key="logo.name" role="img" :aria-label="logo.name" class="logo-item inline-flex items-center justify-center w-48 h-20 bg-gray-50 dark:bg-dark-surface rounded-xl mx-6 shadow-sm border border-gray-100 dark:border-indigo-900/50">
            <div v-html="logo.svg" class="w-full h-full max-h-12 max-w-full object-contain flex items-center justify-center [&>svg]:w-full [&>svg]:h-full"></div>
          </div>
        </div>
        <div class="absolute top-0 animate-marquee2 whitespace-nowrap flex items-center py-4">
          <div v-for="logo in cloudPartners" :key="logo.name + '-dup'" role="img" :aria-label="logo.name" class="logo-item inline-flex items-center justify-center w-48 h-20 bg-gray-50 dark:bg-dark-surface rounded-xl mx-6 shadow-sm border border-gray-100 dark:border-indigo-900/50">
            <div v-html="logo.svg" class="w-full h-full max-h-12 max-w-full object-contain flex items-center justify-center [&>svg]:w-full [&>svg]:h-full"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import cloudPartners from '@/assets/logos/cloud-partners.js'

const { t } = useI18n({ useScope: 'global' })
</script>

<style scoped>
.logo-item { 
  filter: grayscale(100%) opacity(0.5); 
  transition: filter 0.3s ease; 
}
.logo-item:hover { 
  filter: grayscale(0%) opacity(1); 
}
:global(.dark) .logo-item { 
  filter: grayscale(100%) opacity(0.4) brightness(1.5); 
}
:global(.dark) .logo-item:hover { 
  filter: grayscale(0%) opacity(1) brightness(1.2); 
}

.animate-marquee {
  animation: marquee 25s linear infinite;
}
.animate-marquee2 {
  animation: marquee2 25s linear infinite;
}
@keyframes marquee {
  0% { transform: translateX(0%); }
  100% { transform: translateX(-100%); }
}
@keyframes marquee2 {
  0% { transform: translateX(100%); }
  100% { transform: translateX(0%); }
}
</style>
